:host {
  box-shadow: none;
}
:host .aras-accordion__header {
  cursor: pointer;
  background-color: #dddddd;
}
:host .aras-accordion__header:hover {
  background-color: #cccccc;
}
:host .aras-accordion__content {
  background-color: #dddddd;
  overflow: visible;
  transition: none;
}
:host .aras-accordion__toggle-button {
  display: flex;
  align-items: center;
  width: auto;
  pointer-events: none;
}
:host .aras-accordion__toggle-button:before {
  position: relative;
  border: none;
  top: auto;
  left: auto;
  margin: 0 2px 0 8px;
  width: 16px;
  height: 16px;
  background-color: #333333;
  clip-path: polygon(25% 41.67%, 50% 66.67%, 75% 41.67%, 68.75% 35.42%, 50% 54.17%, 31.25% 35.42%);
}
:host .aras-accordion__toggle-button.aras-icon-arrow_up:before {
  transform: rotate(180deg);
  margin-top: 0;
}
:host(.aras-accordion_collapsed) .aras-accordion__toggle-button:before {
  transform: rotate(-90deg);
}
:host([filtered]) .aras-accordion__header {
  background-color: #fef7af;
}
:host([filtered]) .aras-accordion__header:hover {
  background-color: #fdf386;
}
